import _ from 'lodash';
import { getForms } from 'db';

export const SET_FORM_DATA = 'SET_FORM_DATA';
export const SET_FORM_VALUE = 'SET_FORM_VALUE';
export const GET_FORM = 'get form';
export const GET_FORMS = 'get forms';
export const SET_FORM_TARGET = 'set form taraget';
export const SET_CURRENT_FORM = 'set current form';

export const setFormData = (formData, target, valueState) => (dispatch) => {
  dispatch({
    type: SET_FORM_DATA,
    payload: {
      formData,
      target,
      valueState
    }
  })
}

export const setFormTarget = (target) => dispatch => {
  dispatch({
    type: SET_FORM_TARGET,
    payload: target
  })
}

export const setFormValueState = (dotNotationKey, value) => (dispatch, getState) => {
  const valueState = getState().form.valueState;
  const newValueState = _.set(valueState, dotNotationKey, value);

  dispatch({
    type: SET_FORM_VALUE,
    payload: newValueState,
  })
}

// CRUD
export const getFormsAction = () => (dispatch) => {
  getForms()
    .then(forms => {
      const grouped_forms = _.groupBy(forms, form => form.data().영역);
      dispatch({
        type: GET_FORMS,
        payload: { forms, grouped_forms }
      })
    })
}

export const setCurrentForm = (form) => dispatch => {
  dispatch({
    type: SET_CURRENT_FORM,
    payload: form
  })
}